import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TenantStatusModal from '../shared/TenantStatusModal';

import '../../../ControlPanel/sadmin.css';
import '../../Settings/settings.css';

/**
 * /admin/tenant/tenantstatuschange/:id — thin v3 shell that opens the
 * shared TenantStatusModal on mount. Preserves the bookmark URL while
 * delegating all logic to the modal component (also used inline on
 * Edit Tenant + Detail).
 *
 * Closing the modal navigates back; saving the modal navigates back
 * to the tenant list.
 */
const StatusChange = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);

    const manageTenants = localStorage.getItem('manageTenants');
    const manageGeneralSettings = localStorage.getItem('manageGeneralSettings');
    const canChange = manageTenants === '1' || manageGeneralSettings === '1';

    useEffect(() => {
        if (!canChange) {
            window.alert(t('You are not authorized to view this page'));
            window.history.back();
        }
    }, [canChange]);

    if (!canChange) return null;

    return (
        <div className="v3-sadmin">
            <div className="v3-sadmin-hero">
                <div className="v3-sadmin-hero-text">
                    <p className="v3-label" style={{ margin: 0 }}>{t('General settings › Tenants')}</p>
                    <h1 className="v3-display v3-sadmin-greeting">
                        <span className="v3-sadmin-name">{t('Change tenant status')}</span>
                    </h1>
                </div>
            </div>
            {open && (
                <TenantStatusModal
                    tenantId={id}
                    onClose={() => {
                        setOpen(false);
                        navigate(-1);
                    }}
                    onSaved={() => {
                        setOpen(false);
                        navigate(`${process.env.PUBLIC_URL}/admin/tenant/viewtenant/default`);
                    }}
                />
            )}
        </div>
    );
};

export default StatusChange;
